import { cn } from "@/lib/utils";
import { ReadShiftReportDepartmentEntry } from "@/types/shiftReportDepartmentEntry";
import { CellContext } from "@tanstack/react-table";
import { useWatch } from "react-hook-form";
import { hasEntryEnoughEmployees } from "../utils/hasEntryEnoughEmployees";

interface ShiftReportEntryCellInputNameProps {
  cell: CellContext<ReadShiftReportDepartmentEntry, string>;
}

const ShiftReportEntryCellInputName = ({
  cell,
}: ShiftReportEntryCellInputNameProps) => {
  const entry = useWatch({
    name: `department_entries.${cell.row.index}`,
  });
  const error = !hasEntryEnoughEmployees(entry);

  return (
    <h3
      className={cn("text-sm font-medium truncate whitespace-nowrap", {
        "text-red-700": error,
      })}
      data-testid="shift-report-entry-department"
    >
      {cell.getValue()}
    </h3>
  );
};

export default ShiftReportEntryCellInputName;
